import { BaseScenariosService } from './base-scenarios-service';
import { SavedHousingScenario, HousingComparisonData } from '../types/housingComparison';

class HousingScenariosService extends BaseScenariosService<SavedHousingScenario> {
  protected readonly STORAGE_KEY = 'larryshelp_housing_scenarios';
  protected readonly SCENARIO_TYPE = 'housing' as const;

  /**
   * Save a new housing scenario
   */
  async saveHousingScenario(scenario: Omit<SavedHousingScenario, 'id' | 'createdAt'>): Promise<string> {
    return this.saveScenario(scenario);
  }

  /**
   * Get all housing scenarios
   */
  async getAllHousingScenarios(): Promise<Record<string, SavedHousingScenario>> {
    return this.getAllScenarios();
  }

  /**
   * Get a specific housing scenario by ID
   */
  async getHousingScenario(id: string): Promise<SavedHousingScenario | null> {
    return this.getScenario(id);
  }

  /**
   * Update an existing housing scenario
   */
  async updateHousingScenario(id: string, updates: Partial<SavedHousingScenario>): Promise<boolean> {
    return this.updateScenario(id, updates);
  }

  /**
   * Delete a housing scenario
   */
  async deleteHousingScenario(id: string): Promise<boolean> {
    return this.deleteScenario(id);
  }

  /**
   * Get housing scenarios as an array (for easier iteration)
   */
  async getHousingScenariosArray(): Promise<SavedHousingScenario[]> {
    return this.getScenariosArray();
  }

  /**
   * Clear all housing scenarios
   */
  async clearAllHousingScenarios(): Promise<void> {
    return this.clearAllScenarios();
  }
}

export const housingScenariosService = new HousingScenariosService();
export default housingScenariosService;